
import { supabase } from '@/integrations/supabase/client';

export const uploadFileToSupabase = async (
  file: File,
  bucketName: string
): Promise<string> => {
  console.log(`Uploading file to ${bucketName}`);

  // Generate a unique file name with timestamp
  const fileExt = file.name.split('.').pop();
  const timestamp = new Date().getTime();
  const uniqueId = Math.random().toString(36).substring(2, 10);
  const fileName = `${timestamp}-${uniqueId}.${fileExt}`;
  const filePath = `${fileName}`;

  // Check if bucket exists
  try {
    const { data: buckets, error: bucketsError } = await supabase.storage.listBuckets();
    
    if (bucketsError) {
      console.error('Error checking buckets:', bucketsError);
      throw bucketsError;
    }
    
    const bucketExists = buckets?.some(bucket => bucket.name === bucketName);
    const actualBucketName = bucketExists ? bucketName : 'app_assets';
    
    if (!bucketExists) {
      console.warn(`Bucket ${bucketName} does not exist, using app_assets instead`);
    }

    // Upload the file
    const { error: uploadError } = await supabase.storage
      .from(actualBucketName)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (uploadError) {
      console.error('Error uploading file:', uploadError);
      throw uploadError;
    }

    // Get the public URL
    const { data: publicUrlData } = supabase.storage
      .from(actualBucketName)
      .getPublicUrl(filePath);

    console.log('File uploaded successfully, URL:', publicUrlData.publicUrl);
    return publicUrlData.publicUrl;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
};
